'use client';
import { useState } from "react";
import Reveal from "../../components/ui/Reveal";
import styles from "./page.module.css";

const contactCards = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
    ),
    label: "Our Office",
    value: "Addis Ababa, Ethiopia",
    sub: "East Africa HQ",
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
    ),
    label: "Email Us",
    value: "info@infinity-et.com",
    sub: "We reply within 24h",
    href: "mailto:info@infinity-et.com",
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5 19.79 19.79 0 0 1 1.61 4.9 2 2 0 0 1 3.58 2.72h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.5a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
    ),
    label: "Call Us",
    value: "+251 11 123 4567",
    sub: "Mon–Fri, 8AM–6PM",
    href: "tel:+251111234567",
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
    ),
    label: "Working Hours",
    value: "Mon – Fri",
    sub: "8:00 AM – 6:00 PM",
  },
];


export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await new Promise(r => setTimeout(r, 1200));
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <main>
      {/* ── Hero ──────────────────────────── */}
      <section className="pageHero">
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <Reveal>
            <span className="pageHeroLabel">Get In Touch</span>
            <h1 className="pageHeroTitle">Partner with the Leader in East African Medical Infrastructure</h1>
            <p className="pageHeroDesc">
              We offer international investors a rare combination of deeply entrenched regional market access, a stellar compliance and due diligence record, and a highly scalable business model primed for recurring clinical service revenues.
            </p>
          </Reveal>
        </div>
      </section>

      {/* ── Contact cards ─────────────────── */}
      <section className={styles.cardsSection}>
        <div className={styles.container}>
          <div className={styles.cards}>
            {contactCards.map((c, i) => (
              <Reveal key={i} delay={i * 80}>
                <div className={styles.contactCard}>
                  <div className={styles.cardIcon}>{c.icon}</div>
                  <div className={styles.cardBody}>
                    <span className={styles.cardLabel}>{c.label}</span>
                    {c.href ? (
                      <a href={c.href} className={styles.cardValue}>{c.value}</a>
                    ) : (
                      <span className={styles.cardValue}>{c.value}</span>
                    )}
                    <span className={styles.cardSub}>{c.sub}</span>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── Form + Map ────────────────────── */}
      <section className={styles.mainSection}>
        <div className={styles.container}>
          <div className={styles.grid}>

            {/* Left: info + decorative */}
            <Reveal direction="left">
              <div className={styles.infoPanel}>
                <span className={styles.infoLabel}>Let&apos;s Talk</span>
                <h2 className={styles.infoTitle}>We&apos;d Love to Hear From You</h2>
                <p className={styles.infoDesc}>
                  Whether you&apos;re looking to procure medical equipment, need technical support,
                  or want to explore partnership opportunities — our team is here to help.
                </p>

                {/* Quick links */}
                {/* <div className={styles.quickLinks}>
                  <p className={styles.quickTitle}>Quick Actions</p>
                  {[
                    { icon: "🏥", text: "Request Equipment Quote", href: "/healthcare-technology" },
                    { icon: "🔧", text: "Book a Service Visit",    href: "/services" },
                    { icon: "🎓", text: "Training Inquiry",         href: "/services" },
                  ].map((q, i) => (
                    <Link key={i} href={q.href} className={styles.quickLink}>
                      <span>{q.icon}</span>
                      <span>{q.text}</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                    </Link>
                  ))}
                </div> */}

                {/* Map placeholder */}
                {/* <div className={styles.mapBox}>
                  <div className={styles.mapInner}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.35 }}><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                    <p>Addis Ababa, Ethiopia</p>
                    <span>East Africa Headquarters</span>
                  </div>
                </div> */}
              </div>
            </Reveal>

            {/* Right: form */}
            <Reveal direction="right">
              <div className={styles.formCard}>
                {submitted ? (
                  <div className={styles.success}>
                    <div className={styles.successRing}>
                      <div className={styles.successCheck}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      </div>
                    </div>
                    <h3 className={styles.successTitle}>Message Sent!</h3>
                    <p className={styles.successDesc}>
                      Thank you for reaching out. Our team will get back to you within 24 hours.
                    </p>
                    <button className={styles.successBtn} onClick={() => { setSubmitted(false); setForm({ name:"", email:"", phone:"", subject:"", message:"" }); }}>
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <form className={styles.form} onSubmit={onSubmit}>
                    <div className={styles.formHead}>
                      <h2 className={styles.formTitle}>Send a Message</h2>
                      <p className={styles.formSub}>All fields marked * are required</p>
                    </div>

                    <div className={styles.row}>
                      <div className={styles.field}>
                        <label>Full Name <span>*</span></label>
                        <input type="text" name="name" placeholder="Your full name" value={form.name} onChange={onChange} required />
                      </div>
                      <div className={styles.field}>
                        <label>Email Address <span>*</span></label>
                        <input type="email" name="email" placeholder="your@email.com" value={form.email} onChange={onChange} required />
                      </div>
                    </div>

                    <div className={styles.row}>
                      <div className={styles.field}>
                        <label>Phone Number</label>
                        <input type="tel" name="phone" placeholder="+251..." value={form.phone} onChange={onChange} />
                      </div>
                      <div className={styles.field}>
                        <label>Inquiry Type <span>*</span></label>
                        <select name="subject" value={form.subject} onChange={onChange} required>
                          <option value="">Select a subject</option>
                          <option>Equipment Inquiry</option>
                          <option>General Inquiry</option>
                          <option>Institutional Procurement</option>
                          <option>Distribution Partnership</option>
                          <option>Partnership Inquiry</option>
                          <option>OEM Partnership</option>
                        </select>
                      </div>
                    </div>

                    <div className={styles.field}>
                      <label>Message <span>*</span></label>
                      <textarea name="message" placeholder="Tell us about your interest or partnership goals..." rows={5} value={form.message} onChange={onChange} required />
                    </div>

                    <button type="submit" className={`${styles.submit} ${loading ? styles.submitLoading : ''}`} disabled={loading}>
                      {loading ? (
                        <>
                          <span className={styles.spinner} />
                          Sending...
                        </>
                      ) : (
                        <>
                          Send Inquiry
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
                        </>
                      )}
                    </button>
                  </form>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </main>
  );
}
